import { FormControl } from '@angular/forms';
import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
  selector: 'dialog-component',
  templateUrl: './dialog-component.component.html',
  styleUrls: ['./dialog-component.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DialogComponent implements OnInit {
  rangeValues: { id: number; from: string; to: string }[] = [];
  multiValues: { id: number; invoice: string }[] = [];

  fromValue = new FormControl('');
  toValue = new FormControl('');
  invoice = new FormControl('');
  isMultiple: boolean = true;
  isAdd: boolean = false;
  maxLength:number=15;
  searchType: string = '';

  constructor(
    public dialogRef: MatDialogRef<DialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any
  ) {}

  ngOnInit(): void {
    switch (this.dialogData) {
      case 'invoiceNo':
        this.searchType = 'Invoice';
        break;
      case 'cutomerNo':
        this.searchType = 'Customer Number';
        break;
      case 'pin':
        this.searchType = 'Pin';
        break;
      case 'imagePin':
        this.searchType = 'Pin';
        break;
      case 'manifest':
        this.searchType = 'Manifest';
        break;
      default:
        break;
    }
    if(this.searchType=='Pin'){
      this.maxLength=35;
    }else{
      this.maxLength=15;
    }
  }

  addRangeRow() {
    if (this.fromValue.value && this.toValue.value) {
      this.rangeValues.push({
        id: Math.floor(100000 + Math.random() * 900000),
        from: this.fromValue.value as string,
        to: this.toValue.value as string,
      });
      this.fromValue = new FormControl('');
      this.toValue = new FormControl('');
    }
  }

  addMultipleRow() {
    if (this.invoice.value) {
      this.multiValues.push({
        id: Math.floor(100000 + Math.random() * 900000),
        invoice: this.invoice.value as string,
      });
      this.invoice = new FormControl('');
    }
  }

  removeRowValueById(id: number) {
    this.rangeValues = this.rangeValues.filter((row) => row.id !== id);
  }

  removeMultiValueById(id: number) {
    this.multiValues = this.multiValues.filter((row) => row.id !== id);
  }

  changeSelection(event: any) {
    if (event.value === '2') {
      this.isAdd = true;
      this.isMultiple = false;
    } else if (event.value === '1') {
      this.isAdd = false;
      this.isMultiple = true;
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }

  closeDialogWithData() {
    if (this.isMultiple) {
      this.dialogRef.close({
        event: 'range',
        data: this.rangeValues,
        type: this.dialogData,
      });
    } else if (this.isAdd) {
      this.dialogRef.close({
        event: 'multiple',
        data: this.multiValues,
        type: this.dialogData,
      });
    }
  }
}
